import { JSX } from "react";

import Avatar from "@mui/material/Avatar";

import { OrganisationOverview } from "./OrganisationTypes";
import Box from "@mui/material/Box";

export function getLogo(org: OrganisationOverview): JSX.Element {
	if (org.smallLogo) {
		return (
			<Box
				sx={{
					backgroundColor: "primary.main",
					textAlign: "center",
					width: 32,
					height: 32
				}}>
				<img
					src={`data:image;base64,${org.smallLogo}`}
					aria-label="organisation-logo"
					style={{
						display: "inline-block",
						verticalAlign: "middle"
					}}
				/>
			</Box>
		);
	} else {
		const nameInitials = org.name
			.split(" ")
			.map(part => part.slice(0, 1))
			.slice(0, 2);
		return (
			<Avatar
				aria-label="organisation-logo"
				sx={{
					borderColor: "text.secondary",
					bgcolor: "grey.200",
					color: "text.primary",
					textTransform: "uppercase",
					width: 32,
					height: 32
				}}>
				{nameInitials}
			</Avatar>
		);
	}
}
